'use strict';

var React = require('react');

var SvgPageClockIcon = function SvgPageClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12a.75.75 0 0 0-1.5 0v1.293c0 .331.132.65.366.884l.854.853a.75.75 0 0 0 1.06-1.06l-.78-.78v-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.25 17h-4.421a4.5 4.5 0 1 1-3.579-7.938v-3.312a2.75 2.75 0 0 1 2.75-2.75h3a.75.75 0 0 1 .53.22l4.25 4.25c.141.14.22.331.22.53v6.25a2.75 2.75 0 0 1-2.75 2.75Zm-6.5-11.25c0-.69.56-1.25 1.25-1.25h2.25v2.5c0 .966.784 1.75 1.75 1.75h2.5v5.5c0 .69-.56 1.25-1.25 1.25h-3.218a4.501 4.501 0 0 0-3.282-6.438v-3.312Zm6.69 1.5-1.69-1.69v1.44c0 .138.112.25.25.25h1.44Zm-7.44 9.25a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }));
};
SvgPageClockIcon.displayName = "PageClockIcon";

exports.SvgPageClockIcon = SvgPageClockIcon;
